var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "a-modal",
    {
      attrs: {
        title: _vm.title,
        width: 640,
        visible: _vm.visible,
        confirmLoading: _vm.confirmLoading,
      },
      on: { ok: _vm.handleOk, cancel: _vm.handleCancel },
    },
    [
      _c(
        "a-spin",
        { attrs: { spinning: _vm.confirmLoading } },
        [
          _c(
            "a-form",
            { attrs: { form: _vm.form } },
            [
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "打印机名称",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: [
                          "name",
                          {
                            rules: [{ required: true, message: "请输入名称" }],
                          },
                        ],
                        expression:
                          "['name', { rules: [{ required: true, message: '请输入名称' }] }]",
                      },
                    ],
                    attrs: { placeholder: "如：热菜档口机" },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "接入通道",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: ["connectType", { initialValue: "gateway" }],
                          expression:
                            "['connectType', { initialValue: 'gateway' }]",
                        },
                      ],
                      on: {
                        change: (e) => (_vm.connectTypeVal = e.target.value),
                      },
                    },
                    [
                      _c("a-radio", { attrs: { value: "gateway" } }, [
                        _vm._v("门店网关"),
                      ]),
                      _c("a-radio", { attrs: { value: "cloud" } }, [
                        _vm._v("云盒"),
                      ]),
                      _c("a-radio", { attrs: { value: "direct" } }, [
                        _vm._v("直连（预留）"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm.connectType === "gateway"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "所属网关",
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                        },
                      },
                      [
                        _c(
                          "a-select",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["gatewaySn"],
                                expression: "['gatewaySn']",
                              },
                            ],
                            attrs: {
                              placeholder: "选择门店网关",
                              "allow-clear": "",
                              "show-search": "",
                              "option-filter-prop": "children",
                            },
                          },
                          _vm._l(_vm.gateways, function (g) {
                            return _c(
                              "a-select-option",
                              { key: g.sn, attrs: { value: g.sn } },
                              [
                                _vm._v(
                                  _vm._s(g.name) +
                                    "（" +
                                    _vm._s(g.sn ? g.sn : "未配对") +
                                    "）"
                                ),
                              ]
                            )
                          }),
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "网关下目标",
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                        },
                      },
                      [
                        _c(
                          "a-radio-group",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: ["targetType", { initialValue: "tcp" }],
                                expression:
                                  "['targetType', { initialValue: 'tcp' }]",
                              },
                            ],
                            on: {
                              change: (e) =>
                                (_vm.targetTypeVal = e.target.value),
                            },
                          },
                          [
                            _c("a-radio", { attrs: { value: "tcp" } }, [
                              _vm._v("网口打印机（IP）"),
                            ]),
                            _c("a-radio", { attrs: { value: "local" } }, [
                              _vm._v("网关电脑本机打印机"),
                            ]),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm.targetType === "tcp"
                      ? [
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "打印机 IP",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-input", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["ip"],
                                    expression: "['ip']",
                                  },
                                ],
                                attrs: { placeholder: "如 192.168.31.108" },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "a-form-item",
                            {
                              attrs: {
                                label: "端口",
                                labelCol: _vm.labelCol,
                                wrapperCol: _vm.wrapperCol,
                              },
                            },
                            [
                              _c("a-input-number", {
                                directives: [
                                  {
                                    name: "decorator",
                                    rawName: "v-decorator",
                                    value: ["port", { initialValue: 9100 }],
                                    expression:
                                      "['port', { initialValue: 9100 }]",
                                  },
                                ],
                                staticStyle: { width: "120px" },
                                attrs: { min: 1, max: 65535 },
                              }),
                            ],
                            1
                          ),
                        ]
                      : _vm._e(),
                    _vm.targetType === "local"
                      ? _c(
                          "a-form-item",
                          {
                            attrs: {
                              label: "本机打印机名",
                              labelCol: _vm.labelCol,
                              wrapperCol: _vm.wrapperCol,
                            },
                          },
                          [
                            _c("a-input", {
                              directives: [
                                {
                                  name: "decorator",
                                  rawName: "v-decorator",
                                  value: ["localPrinterName"],
                                  expression: "['localPrinterName']",
                                },
                              ],
                              attrs: {
                                placeholder:
                                  "网关电脑上安装的打印机名称（与控制台一致）",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                  ]
                : _vm._e(),
              _vm.connectType === "cloud"
                ? [
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "云盒厂商",
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                        },
                      },
                      [
                        _c(
                          "a-select",
                          {
                            directives: [
                              {
                                name: "decorator",
                                rawName: "v-decorator",
                                value: [
                                  "cloudVendor",
                                  { initialValue: "feie" },
                                ],
                                expression:
                                  "['cloudVendor', { initialValue: 'feie' }]",
                              },
                            ],
                          },
                          [
                            _c(
                              "a-select-option",
                              { attrs: { value: "feie" } },
                              [_vm._v("飞鹅云")]
                            ),
                            _c(
                              "a-select-option",
                              { attrs: { value: "yilianyun" } },
                              [_vm._v("易联云")]
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "a-form-item",
                      {
                        attrs: {
                          label: "厂商参数",
                          labelCol: _vm.labelCol,
                          wrapperCol: _vm.wrapperCol,
                        },
                      },
                      [
                        _c("a-textarea", {
                          directives: [
                            {
                              name: "decorator",
                              rawName: "v-decorator",
                              value: ["vendorConfig"],
                              expression: "['vendorConfig']",
                            },
                          ],
                          attrs: {
                            rows: 3,
                            placeholder:
                              '飞鹅：{"user":"","ukey":"","sn":""}；易联云：{"appId":"","appSecret":"","printerSn":""}',
                          },
                        }),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "纸张宽度",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-radio-group",
                    {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: ["paperType", { initialValue: "80" }],
                          expression: "['paperType', { initialValue: '80' }]",
                        },
                      ],
                    },
                    [
                      _c("a-radio", { attrs: { value: "80" } }, [
                        _vm._v("80mm"),
                      ]),
                      _c("a-radio", { attrs: { value: "58" } }, [
                        _vm._v("58mm"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "打印份数",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("a-input-number", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["copies", { initialValue: 1 }],
                        expression: "['copies', { initialValue: 1 }]",
                      },
                    ],
                    staticStyle: { width: "120px" },
                    attrs: { min: 1, max: 9 },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "打印后走纸",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("a-input-number", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["feedLines", { initialValue: 0 }],
                        expression: "['feedLines', { initialValue: 0 }]",
                      },
                    ],
                    staticStyle: { width: "120px" },
                    attrs: { min: 0, max: 20 },
                  }),
                  _c(
                    "span",
                    { staticStyle: { "margin-left": "8px", color: "#999" } },
                    [_vm._v("额外走纸行数（0=模板默认）")]
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "适用业务",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-checkbox-group",
                    {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: [
                            "businessTypes",
                            { initialValue: ["dine_in"] },
                          ],
                          expression:
                            "['businessTypes', { initialValue: ['dine_in'] }]",
                        },
                      ],
                    },
                    [
                      _c("a-checkbox", { attrs: { value: "dine_in" } }, [
                        _vm._v("堂食"),
                      ]),
                      _c("a-checkbox", { attrs: { value: "takeout" } }, [
                        _vm._v("外卖"),
                      ]),
                      _c("a-checkbox", { attrs: { value: "fast_food" } }, [
                        _vm._v("快餐"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "联次角色",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-checkbox-group",
                    {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: ["roles", { initialValue: [] }],
                          expression: "['roles', { initialValue: [] }]",
                        },
                      ],
                      on: { change: _vm.onRolesChange },
                    },
                    [
                      _c("a-checkbox", { attrs: { value: "merchant" } }, [
                        _vm._v("商家联"),
                      ]),
                      _c("a-checkbox", { attrs: { value: "customer" } }, [
                        _vm._v("顾客联"),
                      ]),
                      _c("a-checkbox", { attrs: { value: "expo" } }, [
                        _vm._v("传菜联"),
                      ]),
                      _c("a-checkbox", { attrs: { value: "area" } }, [
                        _vm._v("区域联"),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { color: "#999", "line-height": "1.6" } },
                    [
                      _vm._v(
                        "商家/顾客联打结算单；传菜联打传菜单（整单/加菜增量）；区域联打区域划菜单（需选择区域或勾选桌台）。各联份数用「联次份数」如 merchant:2,expo:1"
                      ),
                    ]
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "联次份数",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c("a-input", {
                    directives: [
                      {
                        name: "decorator",
                        rawName: "v-decorator",
                        value: ["roleCopies"],
                        expression: "['roleCopies']",
                      },
                    ],
                    attrs: {
                      placeholder: "如 merchant:2,customer:1（默认各 1 份）",
                    },
                  }),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "事件单",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-checkbox-group",
                    {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: ["eventTypes", { initialValue: [] }],
                          expression: "['eventTypes', { initialValue: [] }]",
                        },
                      ],
                    },
                    [
                      _c("a-checkbox", { attrs: { value: "add" } }, [
                        _vm._v("加菜单"),
                      ]),
                      _c("a-checkbox", { attrs: { value: "return" } }, [
                        _vm._v("退菜单"),
                      ]),
                      _c("a-checkbox", { attrs: { value: "change_table" } }, [
                        _vm._v("换桌单"),
                      ]),
                      _c("a-checkbox", { attrs: { value: "void" } }, [
                        _vm._v("作废单"),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "a-form-item",
                {
                  attrs: {
                    label: "所属区域",
                    labelCol: _vm.labelCol,
                    wrapperCol: _vm.wrapperCol,
                  },
                },
                [
                  _c(
                    "a-select",
                    {
                      directives: [
                        {
                          name: "decorator",
                          rawName: "v-decorator",
                          value: ["areaId"],
                          expression: "['areaId']",
                        },
                      ],
                      attrs: {
                        placeholder: "区域服务员联按区域出单（可选）",
                        "allow-clear": "",
                      },
                      on: { change: _vm.onAreaChange },
                    },
                    _vm._l(_vm.areas, function (a) {
                      return _c(
                        "a-select-option",
                        { key: a.id, attrs: { value: a.id } },
                        [_vm._v(_vm._s(a.name))]
                      )
                    }),
                    1
                  ),
                ],
                1
              ),
              _vm.hasAreaRole
                ? _c(
                    "a-form-item",
                    {
                      attrs: {
                        label: "指定桌台",
                        labelCol: _vm.labelCol,
                        wrapperCol: _vm.wrapperCol,
                      },
                    },
                    [
                      _vm.areaIdVal
                        ? [
                            _vm.tables.length
                              ? _c(
                                  "a-checkbox-group",
                                  {
                                    attrs: { value: _vm.checkedTableIds },
                                    on: { change: _vm.onTableCheck },
                                  },
                                  _vm._l(_vm.tables, function (t) {
                                    return _c(
                                      "a-checkbox",
                                      {
                                        key: t.id,
                                        staticStyle: { margin: "0 12px 6px 0" },
                                        attrs: { value: t.id },
                                      },
                                      [_vm._v(_vm._s(t.name))]
                                    )
                                  }),
                                  1
                                )
                              : _c("div", { staticStyle: { color: "#999" } }, [
                                  _vm._v("该区域暂无桌台"),
                                ]),
                            _c(
                              "div",
                              {
                                staticStyle: {
                                  color: "#999",
                                  "line-height": "1.6",
                                },
                              },
                              [
                                _vm._v(
                                  "未勾选桌台=整区出票；勾选后区域联仅对勾选桌台的订单出票（同区域多台打印机可各管部分桌台）"
                                ),
                              ]
                            ),
                          ]
                        : _c("div", { staticStyle: { color: "#999" } }, [
                            _vm._v(
                              "请先选择所属区域，再勾选该区域的桌台；不勾选则整区出票"
                            ),
                          ]),
                    ],
                    2
                  )
                : _vm._e(),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }